(function () {
  function formatMessage(prefix, count, singular, plural) {
    var pfx = (prefix || "Recommended").trim();
    var s = singular || "unit";
    var p = plural || s + "s";
    var label = count === 1 ? s : p;
    return pfx + ": " + count + " " + label;
  }

  function bind(root) {
    var input = root.querySelector("[data-coverage-area-input]");
    var out = root.querySelector("[data-coverage-result]");
    var placeholder = root.querySelector("[data-coverage-placeholder]");
    var outBox = root.querySelector("[data-coverage-output-box]");
    if (!input || !out) return;

    var per = parseFloat(root.getAttribute("data-coverage-per-unit"), 10);
    var singular = root.getAttribute("data-unit-singular") || "unit";
    var plural = root.getAttribute("data-unit-plural") || "";
    var prefix = root.getAttribute("data-i18n-prefix") || "Recommended:";

    function update() {
      var area = parseFloat(String(input.value).replace(",", "."), 10);
      if (!per || per <= 0 || !area || area <= 0 || Number.isNaN(area)) {
        out.textContent = "";
        out.hidden = true;
        if (placeholder) placeholder.hidden = false;
        if (outBox) outBox.classList.remove("m-coverage-calculator__output-box--active");
        return;
      }
      var n = Math.ceil(area / per);
      out.textContent = formatMessage(prefix, n, singular, plural);
      if (placeholder) placeholder.hidden = true;
      out.hidden = false;
      if (outBox) outBox.classList.add("m-coverage-calculator__output-box--active");
    }

    input.addEventListener("input", update);
    input.addEventListener("change", update);
  }

  function initAll() {
    document.querySelectorAll("[data-coverage-calculator]").forEach(bind);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();
